import styled, { borderRadius, spacing } from "@rentiohq/web-theme";

export const List = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.neutral30};
  border-radius: ${borderRadius("large")};
  background: ${({ theme }) => theme.colors.neutral0};
  overflow: hidden;
`;

export const Group = styled.div`
  padding: ${spacing("base")} ${spacing("loose")} ${spacing("tight")};
  background: ${({ theme }) => theme.colors.neutral10};
  border-top: 1px solid ${({ theme }) => theme.colors.neutral20};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.getColor("primary")};

  &:first-child {
    border-top: 0;
  }
`;

// Scrolled to from a search result, clear of the dashboard's top bar.
export const Item = styled.div`
  scroll-margin-top: calc(
    ${({ theme }) => theme.header.height}px + ${spacing("base")}
  );
  border-top: 1px solid ${({ theme }) => theme.colors.neutral20};
`;

export const Question = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing("base")};
  width: 100%;
  margin: 0;
  padding: ${spacing("base")} ${spacing("loose")};
  border: 0;
  background: none;
  color: ${({ theme }) => theme.colors.neutral100};
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.neutral10};
  }
`;

export const Answer = styled.div`
  padding: 0 ${spacing("loose")} ${spacing("loose")};
`;
